export default __webpack_public_path__ + "static/media/rabbit-yellow.bdcf246b.svg";